var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "alert-maxi-standalone" },
    [
      _c("iframe", {
        ref: "frame",
        class: { "with-button": _vm.isAcked },
        attrs: { src: _vm.getUrl },
      }),
      _vm._v(" "),
      _vm.isAcked
        ? _c("Btn", {
            staticClass: "block primary reverse",
            domProps: { innerHTML: _vm._s(_vm.$t("alerts.btns.printRecord")) },
            nativeOn: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.printAlertRecord($event)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("LoadingMini", { ref: "loading" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }